/* COMPONENT - C09.02 Language Footer */
'use strict';

export default class LanguageFooter {
    constructor(element) {
        this.root = element;
        this.langSelect = this.root.querySelector('.language-footer__select');
        this.bindEvents();
    }
    bindEvents() {
        this.langSelect.addEventListener('change', this.submitForm.bind(this));
    }
    submitForm() {
        this.root.submit();
    }
}
